<template>
  <div class="uploader__container">
    <div :class="['uploader']">
      <form @submit.prevent="createBlocks">
        <div class="form-section">
          <label class="select-concept-label" for="concept-select">Concept:</label>
          <select class="select-concept" name="concept-select" v-model="concept">
           <option v-for="(concept, index) in $store.state.org.concepts" v-bind:key="index">{{ concept.name }}</option>
           <option key="last-option">New Concept +</option>
          </select>
          <input class="newConceptInput" type="text" v-if="concept == 'New Concept +'" placeholder="New Concept Name" v-model="newConceptName"/>
          <br>
        </div>
        <div class="divider"></div>
        <UploadBlock v-for="(material, index) in materials" :key="index" ref="uploadBlocks" :materialValue="material" @remove="removeBlock(material.id)" @addFile="addFile" @nowHasMaterial="blockNowHasMaterial" @noLongerHasMaterial="blockNoLongerHasMaterial" :valid="material.valid" :id="material.id"></UploadBlock>
        <!--<div class="form-section" v-if="canAddNewBlock">
          <button @click="addNewBlock" class="newBlockButton">+ Text or Upload</button>
        </div>-->
        <div class="specialSpacer" v-if="!canAddNewBlock"></div>
        <div class="divider"></div>
        <div class="form-section">
          <input class="uploader-name" type="text" placeholder="Uploader" v-model="uploader" hidden />
          <button class="primary" type="submit">{{ addButtonLabel }} to {{conceptNameLabel}}</button>
          <p v-if="$store.state.trust.newBlock.savingBlock">{{ addStatus }}</p>
          <p v-if="savingMessage != ''">{{ savingMessage }}</p>
          <!--<button style="width: fit-content;" @click="cancelUpload" v-if="viewStyle == 'top-left'">Cancel</button>-->
          <p style="color: orange" v-if="errorMessage">{{ errorMessage }}</p>
          <p style="color: orange" v-if="$store.state.trust.newBlock.errorSavingMessage"> {{ $store.state.trust.newBlock.errorSavingMessage }} </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { db, storage } from '@trust/firebase'
  import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
  import { collection, doc, setDoc, addDoc, getDoc, getDocs } from "firebase/firestore";
  import UploadBlock from '@trust/components/UploadBlock.vue'

   export default {
      name: 'Uploader',
      components: {
        UploadBlock,
      },
      data(){
         return{
          materials: [],
          useFirstBlockTemplate: true,
          blockIdCount: 0,
          newConceptName: null,
          concept: '',
          uploader: '',
          successMessage: '',
          errorMessage: '',
          uploadProgress: '',
          savingMessage: '',
          canAddNewBlock: false,
         }
      },
      computed: {
        conceptNameLabel(){
          let conceptName = this.concept;
          if(conceptName == 'New Concept +'){
            conceptName = this.newConceptName;
          }
          return conceptName;
        },
        addButtonLabel(){
          if(this.$refs.uploadBlocks){
            let ideaBlocks = this.$refs.uploadBlocks.filter(b => { console.log(b); return b.valid == true && b.blockData.type == 'Idea' && (b.blockData.fileData != null || b.blockData.text != '')});
            let referenceBlocks = this.$refs.uploadBlocks.filter(b => { console.log(b); return b.valid == true && b.blockData.type == 'Reference' && (b.blockData.fileData != null || b.blockData.text != '')});

            let ideaCount = ideaBlocks.length;
            let referenceCount = referenceBlocks.length;
            console.log('idea and reference count', ideaCount, referenceCount)

            if(ideaCount > 0 || referenceCount > 0){
              let label = 'Add ';
              if(ideaCount == 1){
                label += '1 Idea';
              } else if (ideaCount > 1){
                label += ideaCount + ' Ideas';
              }

              if(referenceCount > 0 && ideaCount > 0){
                label += ' and '
              }

              if(referenceCount == 1){
                label += '1 Reference';
              } else if(referenceCount > 1){
                label += referenceCount + ' References';
              }

              return label;

            } else {
              return 'Add';
            }
          } else {
            return 'Add';
          }
        },
        addStatus(){
          let amountSaving = this.$store.state.trust.newBlock.amountSaving;
          if(amountSaving == 1){
            return 'Adding idea...';
          } else {
            return 'Adding ' + amountSaving + ' ideas...';
          }
        }
      },
      created() {
        // Listen for paste event
        window.addEventListener("paste", this.pastedMaterial, false);

        // Listen for drops
        window.addEventListener("drop", this.droppedMaterial, false);
        window.addEventListener('dragover', this.handleDragOver);
        window.addEventListener('dragleave', this.handleDragLeave);

        this.addBlankBlock();

        if(this.$store.state.walletConnect.user.displayAddress){
          this.uploader = this.$store.state.walletConnect.user.displayAddress;
        }
      },
      destroyed() {
        window.removeEventListener('paste');
        window.removeEventListener('drop');
        window.removeEventListener('dragover');
        window.removeEventListener('dragleave');
      },
      mounted() {
      },
      methods:{
         timeout(ms){
           return new Promise(resolve => setTimeout(resolve, ms));
         },
         cancelUpload(e){
           e.preventDefault();
           this.$store.commit('closeNewBlock', {reason: 'cancel'});
           this.$store.commit('closeLeft');
         },
         addBlankBlock(){
           this.addBlock({
             text: '',
           });
         },
         addBlock(materialValue){
           // Check if we should remove the first template UploadBlock
           if(this.$refs.uploadBlocks){
             let validBlocks = this.$refs.uploadBlocks.filter(b => b.valid == true)
             console.log('checking for valid blocks: ')
             console.log(validBlocks)
             if(validBlocks.length == 1){
               console.log('theres only one valid block')
               console.log('first valid block filedata is: ', validBlocks[0].blockData.fileData)
               if(validBlocks[0].blockData.fileData == null && validBlocks[0].blockData.text == ''){
                 let index = this.materials.findIndex(b => b.id == validBlocks[0].id)
                 console.log('updating at index: ', index, this.materials)
                 console.log('from: ', validBlocks[0].id)
                 this.materials[index].valid = false;

               }
             }
           }

           this.blockIdCount++;
           materialValue.id = 'block-' + this.blockIdCount;
           materialValue.valid = true;
           this.materials.push(materialValue);
         },
         removeBlock(id){
           console.log('Uploader.removeBlock removing')
           // Make the block invalid, and if none are left
           // then add a new blank one
           let index = this.materials.findIndex(m => m.id == id);
           this.materials[index].valid = false;

           let stillValid = false;
           this.materials.forEach(m => { if(m.valid == true) { stillValid = true; } })
           if(!stillValid) {
             console.log('Uploader.removeBlock adding a blank block')
             this.addBlankBlock();
           }
         },
         async createBlocks(){
           // Create new concept if we need one,
           // then create each block

           if(this.concept == ''){
             this.errorMessage = "Select a Concept to add to.";
             return;
           }

           if(this.concept == 'New Concept +' && this.newConceptName == null){
             this.errorMessage = "Name the new Concept before adding.";
             return;
           }

           if(this.$store.state.trust.newBlock.savingBlock) {
             console.log('Already saving blocks')
             return;
           }

           let unuploadedBlocks = this.$refs.uploadBlocks.filter(b => { return b.valid == true && (b.blockData.fileData != null && b.uploadProgress != 100)});
           if(unuploadedBlocks.length != 0){
             this.errorMessage = "Wait until all files are uploaded and try again.";
             return;
           }

           let validBlocks = this.$refs.uploadBlocks.filter(b => { return b.valid == true && (b.blockData.fileData != null || b.blockData.text != '')});
           console.log('Starting to add ' + validBlocks.length + ' blocks')
           if(validBlocks.length == 0){
             this.errorMessage = "No ideas found. Fill in an idea to add.";
             return;
           }

           let conceptName = this.concept;
           if(this.newConceptName != null) {
             let newConceptName = this.newConceptName;
             this.$store.commit('createConcept', { newConceptName })
             conceptName = newConceptName;
           }

           let concept = this.$store.state.org.concepts.find(concept => concept.name == conceptName);
           while(concept == undefined) {
             console.log('waiting for new concept to be created');
              await this.timeout(400);
              console.log(this.$store.state.org.concepts);
              concept = this.$store.state.org.concepts.find(concept => concept.name == conceptName);
           }
           let conceptId = concept.id;

           validBlocks.forEach(block => {
             block.createBlock(this.uploader, conceptId);
           });
         },
         pastedMaterial(e){
           let noFocusedInputs = (document.querySelectorAll('input:focus').length == 0);
           let noFocusedTextareas = (document.querySelectorAll('textarea:focus').length == 0);

           // if (e.target.tagName !== "INPUT" && e.target.tagName !== "TEXTAREA") {
           if(noFocusedInputs && noFocusedTextareas) {
             // Proceed if we're not already focused on an input

             // Stop data being pasted anywhere
             e.stopPropagation();
             e.preventDefault();

             this.$store.commit('openNewBlock');
             this.$store.dispatch('openLeft');

             // Check for text first
             let clipboardData = e.clipboardData || window.clipboardData;
             let pastedText = clipboardData.getData("Text");
             if (pastedText) {
               this.addBlock({ text: pastedText });
             } else {
               // Then check for files
               let items = e.clipboardData.items;
               for (let i = 0; i < items.length; i++) {
                 if (items[i].kind === "file") {
                   let file = items[i].getAsFile();
                   this.addBlock({ file });
                 }
               }
             }
           }
         },
         handleDragOver(e){
            e.stopPropagation();
            e.preventDefault();
            this.$store.commit('startDragging');
         },
         handleDragLeave(e){
            e.stopPropagation();
            e.preventDefault();
            this.$store.commit('stopDragging');
         },
         droppedMaterial(e){
           // Handle single and multiple file drops
           e.preventDefault();
           this.$store.commit('stopDragging');
           this.$store.commit('openNewBlock');
           this.$store.dispatch('openLeft');

           let files = e.dataTransfer.files;
           let text = e.dataTransfer.getData('text');

           if(files.length > 0 && files.length == 1) {
             this.addBlock({ file: files[0] })
           } else if (files.length > 1){
             console.log('multiple files')
             for(let i = 0; i < files.length; i++) {
               this.addBlock({ file: files[i] })
             }
           }

           if(text != '') {
             this.addBlock({ text: text })
           }

         },
         addFile(fileObj){
           this.addBlock(fileObj);
         },
        resetData(reason){
          this.newConceptName = null;
          this.savingMessage = null;
          this.errorMessage = null;
          this.$refs.uploadBlocks.forEach(function(b) {
            if(b.valid){
              b.deleteBlock(reason)
            }
          });
        },
        blockNowHasMaterial(){
          // show new block button
          this.canAddNewBlock = true;
        },
        blockNoLongerHasMaterial(){
          // hide new block button
          this.canAddNewBlock = false;
        },
        addNewBlock(){
          this.addBlankBlock();
          this.canAddNewBlock = false;
        }
     },
     watch: {
       '$store.state.trust.newBlock.savingBlock' (to) { // can also be (to, from)
         if(to == false && !this.$store.state.trust.newBlock.errorSaving) {

           this.savingMessage = 'Added!';
           setTimeout(function(){
             this.savingMessage = '';
             this.$store.commit('closeNewBlock', {reason: 'success'});
             this.$store.dispatch('closeLeft');
           }.bind(this), 500);
         }
       },
       '$store.state.trust.newBlock.showModal' (to) { // can also be (to, from)
         if(to == false) {
           this.resetData(this.$store.state.trust.newBlock.modalCloseReason);
         }
       },
       '$store.state.trust.viewingConcept' (to) {
         let conceptName = this.$store.state.org.concepts.find(c => c.id == to).name;
         this.concept = conceptName;
       },
       '$store.state.walletConnect.user.displayAddress' (to) {
         this.uploader = to;
       },
       '$refs.uploadBlocks'(to) {
         console.log(to)
       }
     },
   }
</script>

<style>

  .uploader__container {
    position: relative;
    height: 100%;
    width: 100%;
    overflow-y: scroll;
  }

  .uploader {
    width: 100%;
    box-sizing: border-box;
  }

  .uploader form {
    width: 100%;
  }

  .uploader form .form-section {
    padding: 15px;
    box-sizing: border-box;
  }

  .uploader .divider {
    height: 2px;
    width: 100%;
    background: var(--beige-500);
  }

  .uploader form textarea,
  .uploader form input,
  .uploader form button,
  .uploader form label {
    width: 100%;
    margin-bottom: 8px;
    box-sizing: border-box;
  }

  .uploader .newBlockButton {
    border-radius: 5px;
    padding: 8px;
    font-weight: 400;
  }

  .uploader .specialSpacer {
    height: 22px;
  }

  .uploader .uploader-name {
    background: var(--beige-900);
    padding: 4px 8px;
    border: none;
    font-family: 'Untitled', sans-serif;
    line-height: 150%;
  }

  .uploader .select-concept-label {
    font-family: 'Untitled', sans-serif;
    font-size: 14px;
    margin-right: 4px;
  }

  .uploader .select-concept {
    font-family: 'Untitled', sans-serif;
    font-size: 14px;
    background: var(--beige-200);
    padding: 0px;
    border-radius: 4px;
    border: 1px solid var(--beige-350);
    cursor: pointer;
  }

  .uploader .newConceptInput {
    font-family: 'Untitled', sans-serif;
    line-height: 150%;
    padding: 4px 6px;
    background: var(--beige-600);
    border: none;
    border-top: 2px solid var(--beige-300);
    outline: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

</style>
